import { makeAutoObservable, observable, action } from 'mobx'

export class MetamaskMobileStore {
  constructor() {
    makeAutoObservable(this)
  }

  @observable
  metamaskMobileLoading = false

  @action
  setLoading(isLoading: boolean) {
    this.metamaskMobileLoading = isLoading
  }
}

export const metamaskMobileStore = new MetamaskMobileStore()
